const AudioPlayer = ({ src, className="w-[150px]" }) => {
    return (
      <audio controls src={src} className={`h-[100px] rounded-md ${className}`}>
        Your browser does not support the audio element.
      </audio>
    );
};

export default AudioPlayer;  